import React from 'react'

import mutation from './mutation.graphql'

import DeleteEntityModal from 'components/shared/DeleteEntityModal'

export default function DeleteCamperModal(props) {
  const { camper } = props

  return (
    <DeleteEntityModal
      entity={camper}
      modalId={`confirmDeleteCamper${camper.id}`}
      fieldGroup='campers'
      modalTitle='Delete Camper?'
      successMessage='Camper Deleted'
      mutation={mutation}
      mutationName='deleteCamper'
      {...props}
    />
  )
}
